export const SPEND_COUNT_COLUMN_WIDTH_PX = 96;
export const SPEND_AMOUNT_COLUMN_WIDTH_PX = 148;
export const SPEND_PERCENT_COLUMN_WIDTH_PX = 96;

/** Half-width drill-in cards. Wide enough for the header and a typical value. */
export const COMPACT_LABEL_COLUMN_WIDTH_PX = 160;
export const COMPACT_GL_CODE_COLUMN_WIDTH_PX = 108;
export const COMPACT_SPEND_AMOUNT_COLUMN_WIDTH_PX = 120;
export const COMPACT_SPEND_PERCENT_COLUMN_WIDTH_PX = 88;

export function fixedColumnWidth(width: number): {
    minWidth: number;
    maxWidth: number;
} {
    return { minWidth: width, maxWidth: width };
}
